"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*******************************************************************
 * Actions
 *******************************************************************/
exports.SET_PARTICIPANT_PROGRESS = 'SET_PARTICIPANT_PROGRESS';
exports.SET_PAX_PLAN_DETAILS = 'SET_PAX_PLAN_DETAILS';
exports.NO_SAVED_MSG = 'noSavedMsg';
exports.ADD_PLAN = 'ADD_PLAN';
exports.ACTION_STEP_UPDATED = 'ACTION_STEP_UPDATED';
exports.PLAN_UPDATED = 'PLAN_UPDATED';
exports.UNLOAD_PROGRESS_DATA = 'UNLOAD_PROGRESS_DATA';
exports.SET_VIEW_PROGRESS_DATA = 'SET_VIEW_PROGRESS_DATA';
exports.SET_VIEW_ORG_TABLE_DATA = 'SET_VIEW_ORG_TABLE_DATA';
exports.ADD_VIEW_ORG_HIERARCHY = 'ADD_VIEW_ORG_HIERARCHY';
exports.SLICE_VIEW_ORG_HIERARCHY = 'SLICE_VIEW_ORG_HIERARCHY';
//# sourceMappingURL=action-types.js.map